import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PhonesInterfaceRequest, crcInterfaceResponse, EmailInterfaceRequest } from '../../interfaces/crc-consults.interface';
import { Global } from '../global';

@Injectable({
  providedIn: 'root'
})
export class CrcConsultService {
  
  private API_URL: string;

  constructor(private httpClient: HttpClient) {
    this.API_URL = Global.url + '/crc'
  }

  consultPhones(token: string, request: PhonesInterfaceRequest): Observable<crcInterfaceResponse> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });  
    return this.httpClient.post<crcInterfaceResponse>(this.API_URL, request, { headers });
  }

  consultEmails(token: string, request: EmailInterfaceRequest): Observable<crcInterfaceResponse> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });  
    return this.httpClient.post<crcInterfaceResponse>(this.API_URL, request, { headers });
  }
}
